import { render, staticRenderFns } from "./activePlayers.vue?vue&type=template&id=3abe61aa&scoped=true"
import script from "./activePlayers.vue?vue&type=script&lang=js"
export * from "./activePlayers.vue?vue&type=script&lang=js"
import style0 from "./activePlayers.vue?vue&type=style&index=0&id=3abe61aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe61aa",
  null
  
)

export default component.exports